import { request } from '../../services/request';
import { PaginatedDataStore } from '../paginated-data.store';
import { Post } from './trade-sharing.store';
import {
    AbstractSocialTradingStore,
    GetFilterValuesResponse,
    PaginationInterface,
} from './abstract-social-trading.store';

export interface SharedAnalysisInterface {
    id: string;
    symbol: string;
    setup_file: any;
    posts: Post[];
}

export interface SharedAnalysisFiltersInterface {
    date_lower?: string;
    date_upper?: string;
    group?: number;
    symbol?: string;
    author?: number;
    user?: number;
    webinar?: number;
}

export class AnalysisSharingStore extends AbstractSocialTradingStore<
    SharedAnalysisInterface,
    SharedAnalysisFiltersInterface
> {
    createPaginatedDataStore(): PaginatedDataStore<SharedAnalysisInterface, SharedAnalysisFiltersInterface> {
        return new PaginatedDataStore(async (page, filters) => {
            const response = await request.get<PaginationInterface<SharedAnalysisInterface>>(
                '/api/v2.0/analysis-sharing/analyses',
                {
                    params: {
                        page,
                        ...(filters.date_upper && { date_upper: filters.date_upper }),
                        ...(filters.date_lower && { date_lower: filters.date_lower }),
                        ...(filters.symbol && { symbol: filters.symbol }),
                        ...(filters.group && { group: filters.group }),
                        ...(filters.webinar && { webinar: filters.webinar }),
                        ...(filters.author && { author: filters.author }),
                        ...(filters.user && { user: filters.user }),
                    },
                }
            );

            return {
                data: response.data.data,
                hasNextPage: page < response.data.last_page,
            };
        });
    }

    async fetchFilterOptions(): Promise<GetFilterValuesResponse> {
        const { data } = await request.get<GetFilterValuesResponse>('/api/v2.0/analysis-sharing/filter-values');
        return data;
    }
}

export const analysisSharingStore = new AnalysisSharingStore();
